




























import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import draggable from 'vuedraggable';
import {Splitpanes, Pane} from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';

@Component({
  components: {
    draggable,
    Splitpanes,
    Pane,
  },
})
export default class DragList extends Vue {
  // Ключ для перерисовки splitpane
  splitpaneRedrawKey = 0;

  // Показатель редактирования
  @Prop({required: false, default: false})
  edit!: boolean;

  @Prop({required: false, default: false})
  separateScroll!: boolean;

  // Модель колонок
  @Prop({required: true})
  columns!: any;

  @Prop({required: true})
  changedItemsMap!: any;

  // Ключ для перерисовки диаграмм
  resizedKey = 0;

  @Watch('columns')
  onChangedColumns() {
    this.splitpaneRedrawKey++;
  }

  // Действия при изменении размера pane
  onPaneResized() {
    this.resizedKey++;
  }
}
